import { formNaming } from '../components/forms/NewCommunicationForm/constants';
import { OrderType } from '../types/orders';

/**
 * Helper function to get the correct modal key based on the tab index
 * This ensures that OT and Campaign selections are stored independently in Redux
 * 
 * @param namingPersistForm - The base form naming (e.g., 'new-communication-form')
 * @param tabIndex - The current tab index (0 = Create, 1 = Relate OT, 2 = Relate Campaign)
 * @returns The correct key with suffix if needed
 */
export const getModalKeyByTab = (
  namingPersistForm: string,
  tabIndex: number
): string => {
  console.log('[getModalKeyByTab] Input:', { namingPersistForm, tabIndex });
  
  if (tabIndex === 1) {
    // Return the appropriate OT constant based on the form type
    if (namingPersistForm === formNaming.NEW_COMMUNICATION_FORM) {
      console.log('[getModalKeyByTab] Returning:', formNaming.NEW_COMMUNICATION_FORM_OT);
      return formNaming.NEW_COMMUNICATION_FORM_OT;
    }
    if (namingPersistForm === formNaming.EDIT_COMMUNICATION_FORM) {
      console.log('[getModalKeyByTab] Returning:', formNaming.EDIT_COMMUNICATION_FORM_OT);
      return formNaming.EDIT_COMMUNICATION_FORM_OT;
    }
    if (namingPersistForm === formNaming.NEW_DUPLICATE_COMMUNICATION_FORM) {
      console.log('[getModalKeyByTab] Returning:', formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_OT);
      return formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_OT;
    }
  }
  
  if (tabIndex === 2) {
    // Return the appropriate Campaign constant based on the form type
    if (namingPersistForm === formNaming.NEW_COMMUNICATION_FORM) {
      console.log('[getModalKeyByTab] Returning:', formNaming.NEW_COMMUNICATION_FORM_CAMPAIGN);
      return formNaming.NEW_COMMUNICATION_FORM_CAMPAIGN;
    }
    if (namingPersistForm === formNaming.EDIT_COMMUNICATION_FORM) {
      console.log('[getModalKeyByTab] Returning:', formNaming.EDIT_COMMUNICATION_FORM_CAMPAIGN);
      return formNaming.EDIT_COMMUNICATION_FORM_CAMPAIGN;
    }
    if (namingPersistForm === formNaming.NEW_DUPLICATE_COMMUNICATION_FORM) {
      console.log('[getModalKeyByTab] Returning:', formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN);
      return formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN;
    }
  }
  
  console.log('[getModalKeyByTab] Returning base key:', namingPersistForm);
  return namingPersistForm;
};

/**
 * Helper to get the correct modal key based on parent order type
 * Used when loading data in edit mode
 * 
 * @param namingPersistForm - The base form naming
 * @param parentOrderType - The type of parent order (from OrderType enum)
 * @returns The correct key with suffix if needed
 */
export const getModalKeyByOrderType = (
  namingPersistForm: string,
  parentOrderType: string | undefined
): string => {
  console.log('[getModalKeyByOrderType] Input:', { namingPersistForm, parentOrderType });
  
  // Check if it's a Campaign type
  if (parentOrderType === OrderType.Campaign || parentOrderType?.toLowerCase() === 'campaign') {
    // Return the appropriate Campaign constant based on the form type
    if (namingPersistForm === formNaming.NEW_COMMUNICATION_FORM) {
      console.log('[getModalKeyByOrderType] Returning:', formNaming.NEW_COMMUNICATION_FORM_CAMPAIGN);
      return formNaming.NEW_COMMUNICATION_FORM_CAMPAIGN;
    }
    if (namingPersistForm === formNaming.EDIT_COMMUNICATION_FORM) {
      console.log('[getModalKeyByOrderType] Returning:', formNaming.EDIT_COMMUNICATION_FORM_CAMPAIGN);
      return formNaming.EDIT_COMMUNICATION_FORM_CAMPAIGN;
    }
    if (namingPersistForm === formNaming.NEW_DUPLICATE_COMMUNICATION_FORM) {
      console.log('[getModalKeyByOrderType] Returning:', formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN);
      return formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN;
    }
  }
  
  // For any other order type (Generic, SubOrder, etc.), treat as OT
  if (parentOrderType && parentOrderType !== OrderType.Campaign) {
    // Return the appropriate OT constant based on the form type
    if (namingPersistForm === formNaming.NEW_COMMUNICATION_FORM) {
      console.log('[getModalKeyByOrderType] Returning:', formNaming.NEW_COMMUNICATION_FORM_OT);
      return formNaming.NEW_COMMUNICATION_FORM_OT;
    }
    if (namingPersistForm === formNaming.EDIT_COMMUNICATION_FORM) {
      console.log('[getModalKeyByOrderType] Returning:', formNaming.EDIT_COMMUNICATION_FORM_OT);
      return formNaming.EDIT_COMMUNICATION_FORM_OT;
    }
    if (namingPersistForm === formNaming.NEW_DUPLICATE_COMMUNICATION_FORM) {
      console.log('[getModalKeyByOrderType] Returning:', formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_OT);
      return formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_OT;
    }
  }
  
  console.log('[getModalKeyByOrderType] Returning base key:', namingPersistForm);
  return namingPersistForm;
};

